export const Loading = ({ className = "" }: { className?: string }) => (
  <div className={`b-loading b-loading--root ${className}`}>
    <div className="b-loading__spinner" />
  </div>
);
